'use client'
import { getCurrentTime, TimeState } from '@/utils/get-hours-minutes'
import { useEffect, useState } from 'react'

const useCurrentTime = () => {
  const [time, setTime] = useState<TimeState>(() => getCurrentTime())

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(getCurrentTime())
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return time
}

export default useCurrentTime
